<template>
  <vxe-grid
    size="small"
    row-id="shipmentGoodsCode"
    border
    resizable
    auto-resize
    show-overflow
    highlight-hover-row
    :toolbar-config="tableToolbar"
    :data="displayData"
    :columns="tableColumns"
    :loading="loading"
    :height="tableHeight"
    :scroll-y="{ enabled: true, gt: 0 }"
    :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
  >
    <template #toolbar_form>
      <slot name="header" />
    </template>

    <template #pager>
      <slot name="pager" />
    </template>

    <template #opt="{ row }">
      <el-tooltip
        :content="$l('INDEX.btn_tips_edit') || '编辑'"
        effect="dark"
        placement="top"
      >
        <i class="el-icon-edit tool-btn" @click="$emit('editCustoms', row)" />
      </el-tooltip>
    </template>

    <template #amzSkuNoHeader>
      <filter-content
        :text="$l('table_label_sku') || 'SKU'"
        :items="options.amzSkuNo"
        @filter="(e) => (filters.amzSkuNo = e)"
        submitFilterOnClose
      />
    </template>
    <template #amzStoreSkuNoHeader>
      <filter-content
        :text="$l('table_label_storeSku') || '店铺 SKU'"
        :items="options.amzStoreSkuNo"
        @filter="(e) => (filters.amzStoreSkuNo = e)"
        submitFilterOnClose
      />
    </template>
    <template #goodsNameHeader>
      <filter-content
        :text="$l('table_label_goodsName') || '产品名称'"
        :items="options.goodsName"
        @filter="(e) => (filters.goodsName = e)"
        submitFilterOnClose
      />
    </template>
    <template #goodsColorHeader>
      <filter-content
        :text="$l('table_label_goodsColor') || '颜色'"
        :items="options.goodsColor"
        @filter="(e) => (filters.goodsColor = e)"
        submitFilterOnClose
      />
    </template>
    <template #ncNoHeader>
      <filter-content
        :text="$l('table_label_ncNo') || 'NC编号'"
        :items="options.ncNo"
        @filter="(e) => (filters.ncNo = e)"
        submitFilterOnClose
      />
    </template>
    <template #storeNameHeader>
      <filter-content
        :text="$l('table_label_storeName') || '店铺名称'"
        :items="options.storeName"
        @filter="(e) => (filters.storeName = e)"
        submitFilterOnClose
      />
    </template>
    <template #amzReplenishmentNoHeader>
      <filter-content
        :text="$l('table_label_amzReplenishmentNo') || '补货单号'"
        :items="options.amzReplenishmentNo"
        @filter="(e) => (filters.amzReplenishmentNo = e)"
        submitFilterOnClose
      />
    </template>
    <template #planNoHeader>
      <filter-content
        :text="$l('form_label_planNos') || '补货计划编号'"
        :items="options.planNo"
        @filter="(e) => (filters.planNo = e)"
        submitFilterOnClose
      />
    </template>
    <template #fbaDcHeader>
      <filter-content
        :text="$l('table_label_fbaDc') || 'FBA DC'"
        :items="options.fbaDc"
        @filter="(e) => (filters.fbaDc = e)"
        submitFilterOnClose
      />
    </template>
    <template #fbaIdHeader>
      <filter-content
        :text="$l('table_label_fbaId') || 'FBA ID'"
        :items="options.fbaId"
        @filter="(e) => (filters.fbaId = e)"
        submitFilterOnClose
      />
    </template>
    <template #fbaIdReferenceIdHeader>
      <filter-content
        :text="$l('table_label_fbaIdReferenceId') || 'FBA Reference ID'"
        :items="options.fbaIdReferenceId"
        @filter="(e) => (filters.fbaIdReferenceId = e)"
        submitFilterOnClose
      />
    </template>
    <template #goodsReadyDateHeader>
      <filter-content
        :text="$l('table_label_goodsReadyDate') || '货好时间'"
        :items="options.goodsReadyDate"
        @filter="(e) => (filters.goodsReadyDate = e)"
        submitFilterOnClose
      />
    </template>
    <template #customerDeliveryDateHeader>
      <filter-content
        :text="$l('table_label_customerDeliveryDate') || '客户交期'"
        :items="options.customerDeliveryDate"
        @filter="(e) => (filters.customerDeliveryDate = e)"
        submitFilterOnClose
      />
    </template>
    <template #loadingDateHeader>
      <filter-content
        :text="$l('table_label_loadingDate') || '产装日期'"
        :items="options.loadingDate"
        @filter="(e) => (filters.loadingDate = e)"
        submitFilterOnClose
      />
    </template>
    <template #scmNameHeader>
      <filter-content
        :text="$l('table_label_scmName') || '出货工厂'"
        :items="options.scmName"
        @filter="(e) => (filters.scmName = e)"
        submitFilterOnClose
      />
    </template>
    <template #ecomWarehouseNameHeader>
      <filter-content
        :text="$l('table_label_ecomWarehouseName') || '出货仓库'"
        :items="options.ecomWarehouseName"
        @filter="(e) => (filters.ecomWarehouseName = e)"
        submitFilterOnClose
      />
    </template>
    <template #invoiceFactoryNameHeader>
      <filter-content
        :text="$l('table_label_invoiceFactoryName') || '开票工厂'"
        :items="options.invoiceFactoryName"
        @filter="(e) => (filters.invoiceFactoryName = e)"
        submitFilterOnClose
      />
    </template>
    <template #shippingFactoryNameHeader>
      <filter-content
        :text="$l('table_label_shippingFactoryName') || '送货工厂'"
        :items="options.shippingFactoryName"
        @filter="(e) => (filters.shippingFactoryName = e)"
        submitFilterOnClose
      />
    </template>
    <template #hscodeHeader>
      <filter-content
        :text="$l('table_label_hscode') || '报关HSCODE'"
        :items="options.hscode"
        @filter="(e) => (filters.hscode = e)"
        submitFilterOnClose
      />
    </template>
    <template #hscodeNameHeader>
      <filter-content
        :text="$l('table_label_hscodeName') || '报关中文品名'"
        :items="options.hscodeName"
        @filter="(e) => (filters.hscodeName = e)"
        submitFilterOnClose
      />
    </template>
    <template #hscodeNameEnHeader>
      <filter-content
        :text="$l('table_label_hscodeNameEn') || '报关英文品名'"
        :items="options.hscodeNameEn"
        @filter="(e) => (filters.hscodeNameEn = e)"
        submitFilterOnClose
      />
    </template>
    <template #originalPlaceHeader>
      <filter-content
        :text="$l('table_label_originalPlace') || '境内货源地'"
        :items="options.originalPlace"
        @filter="(e) => (filters.originalPlace = e)"
        submitFilterOnClose
      />
    </template>
  </vxe-grid>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import {
  applyTableFilters,
  buildFilterOptions,
  resetTableFilters,
} from '../table-filter-helpers'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      filters: {
        amzSkuNo: [],
        amzStoreSkuNo: [],
        goodsName: [],
        goodsColor: [],
        ncNo: [],
        storeName: [],
        amzReplenishmentNo: [],
        planNo: [],
        fbaDc: [],
        fbaId: [],
        fbaIdReferenceId: [],
        goodsReadyDate: [],
        customerDeliveryDate: [],
        loadingDate: [],
        scmName: [],
        ecomWarehouseName: [],
        invoiceFactoryName: [],
        shippingFactoryName: [],
        hscode: [],
        hscodeName: [],
        hscodeNameEn: [],
        originalPlace: [],
      },
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    options() {
      return buildFilterOptions(this.tableData, Object.keys(this.filters))
    },
    displayData() {
      return applyTableFilters(this.tableData, this.filters, this.options)
    },
  },
  watch: {
    tableData() {
      this.resetFilters()
    },
  },
  methods: {
    resetFilters() {
      this.filters = resetTableFilters(this.filters)
    },
  },
}
</script>
